import { useState } from 'react'
import { useSearchParams, Link } from 'react-router-dom'
import axios from 'axios'
import { CheckCircle, XCircle, ArrowLeft } from 'lucide-react'

export default function EventUnsubscribed() {
  const [searchParams] = useSearchParams()
  const [reason, setReason] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [status, setStatus] = useState<'success' | 'error' | null>(null)
  const eventId = searchParams.get('eventId')
  const kind = searchParams.get('kind')
  const token = searchParams.get('token')
  const validLink = Boolean(eventId && token && (kind === 'member' || kind === 'public'))

  const submit = async (event: React.FormEvent) => {
    event.preventDefault()
    if (!validLink) return setStatus('error')
    setSubmitting(true)
    try {
      await axios.post(`/api/events/${eventId}/${kind === 'public' ? 'public-unsubscribe' : 'unsubscribe'}`, { token, reason })
      setStatus('success')
    } catch {
      setStatus('error')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="flex min-h-[70vh] items-center justify-center p-4">
      <div className="card status-panel w-full max-w-lg p-8">
        {status ? (
          <div className="text-center">
            <div className={`mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full ${status === 'success' ? 'bg-green-100' : 'bg-red-100'}`}>
              {status === 'success' ? <CheckCircle className="h-8 w-8 text-green-600" /> : <XCircle className="h-8 w-8 text-red-600" />}
            </div>
            <h1 className="mb-4 text-2xl font-bold text-gray-900">{status === 'success' ? 'Désistement enregistré' : 'Lien invalide ou expiré'}</h1>
            <p className="mb-6 text-gray-600">{status === 'success' ? 'Votre inscription a été retirée et votre motif a bien été transmis au club.' : 'Le désistement n’a pas pu être enregistré. Contactez le club si le problème persiste.'}</p>
          </div>
        ) : (
          <form onSubmit={submit}>
            <p className="eyebrow">Événement</p>
            <h1 className="text-2xl font-bold text-gray-900">Confirmer mon désistement</h1>
            <p className="mt-2 text-sm leading-6 text-gray-600">Pour aider le club à s’organiser, indiquez obligatoirement la raison de votre désistement.</p>
            <label className="form-label mt-6" htmlFor="withdrawal-reason">Motif du désistement</label>
            <textarea id="withdrawal-reason" className="input-field min-h-36 w-full" minLength={3} maxLength={1000} required value={reason} onChange={event => setReason(event.target.value)} />
            <p className="mt-2 text-right text-xs text-gray-500">{reason.length}/1 000</p>
            <button className="btn-danger mt-5 w-full justify-center" disabled={!validLink || reason.trim().length < 3 || submitting}>{submitting ? 'Enregistrement…' : 'Confirmer mon désistement'}</button>
          </form>
        )}
        <div className="mt-6 grid gap-3">
          <Link to="/" className="btn-primary justify-center"><ArrowLeft className="h-4 w-4" /> Retour à l'accueil</Link>
          <Link to="/contact" className="btn-secondary justify-center">Nous contacter</Link>
        </div>
      </div>
    </div>
  )
}
